module.exports = __webpack_public_path__ + "10c54deee4d9f78aa3ed7e3e57006706.png";